const config = {
  basename: '/',
  defaultPath: '/organizacijos/institucijos',
  fontFamily: `'Figtree Variable', 'Figtree', system-ui, -apple-system, 'Segoe UI', sans-serif`,
  borderRadius: 12,
  defaultThemeMode: 'dark',
  logoIcon: ''
};

export default config;